import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import * as lookup from "../../../static/lookup.json"
import * as jounrneyJSON from "../../../static/journeyssr.json"

import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
  whatsAppOptin,
  getTOFpaymentReceipt,
  saveTransactionDetails,
  updateUserTrackerDetails
} from "../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel,
  DataLayerIntegration,
  transformReceiptToTransaction
} from "../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../services/error-handler"
import { wordCapital, lineCapital, applyComma, maskInFormat, calculateAge } from '../../shared/functions'
// import { window, document } from "browser-monads"
import axios from "axios"

const RadioContainer = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background-color: #fff;
    padding: 2px 5px;
    z-index: 999;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    & > .radio-label {
      text-align: center;
    }
  }

  .card {
    width:100%;
    border-radius: 1rem;
    padding: 1rem 0;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    margin: 0px;
    margin-bottom: 0px;
    cursor: pointer;
    height: 9rem;
    margin-top: 0px;
    box-shadow: 0px 0px 20px #ccc;
    transition: all 200ms;

    .amount {
      color: black;
      margin-bottom: 2rem;
      margin-left: 6.5rem;
      border-left: 1px solid #ccc;
      padding-left: 1.5rem;
      height: 3rem;
      font-size: 21px;
    }
    .desc {
      padding: 0.8rem;
      background: #ededed;
      color: black;
      text-align: center;
      padding-right:34px;
    }
  }

  /*Check tick start  */
  .checked {
    background: #ededed;
    color: #ededed;
    position: absolute;
    left: 2rem;
    top: 1rem;
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    padding: 8px;
    & > * {
      font-size: 1.2rem;
    }
  }

  input:checked ~ .card .checked {
    background: #fff;
    color: ${props =>
    props.channel === "A"
      ? "#3e505d"
      : props.channel === "B"
        ? "#a20a3a"
        : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
    color: var(--lumiq-card-bg);
  }
  /*Check tick end */

  .icon-container {
    font-size: 3rem;
    padding: 1rem;
    span {
      border-radius: 50%;
      padding: 1rem;

      background: #3e505d;
      .hero-icon {
        padding-top: 8px;
        color: #fff;
      }
    }
  }

  input:checked ~ .card {
    background-color: ${props =>
    props.channel === "A"
      ? "#3e505d"
      : props.channel === "B"
        ? "#a20a3a"
        : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
    background-color: var(--lumiq-card-bg);
    color: #fff;
    .icon-container-1 {
      span {
        background: #fff;
        .hero-icon {
          color: #3e505d;
        }
      }
    }

    .amount {
      color: white;
      margin-bottom: 1rem;
      margin-left: 6.5rem;
      border-left: 1px solid #ccc;
      padding-left: 1.5rem;
      padding-top: .5rem;
      height: 3rem;
    }
    .desc {
      padding: 0.8rem;
      background: #fff;
      color: black;
      text-align: center;
      padding-right:34px;
    }
  }

  input:not(:checked) ~ .card {
    /* opacity: 0.5; */
    .amount{
      color:#818181;
    }

    .desc{
      color:#3e505d;
    }
  }
`

export default function YoungTermBenefitIllustration(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [conditionState, setConditionState] = useContext(ConditionContext)

  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("later")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
  const [proceedWithOption, setProceedWithOption] = useState()
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(false)
  const [skipPayment, setSkipPayment] = useState(false) ;
  const [isPayBasba, setIsPayBasba] = useState(false)
  //Helper Functions
  console.log(journeyState);
  async function downloadLinkOfPdf(Base64Pdf) {
    // if(!location){
    //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
    //     Base64Pdf: Base64Pdf,
    //   })
    //   setLocation(result.data.location)
    //   window.open(result.data.location,"_self");
    // }else{
    //   window.open(location,"_self");
    // }
   
    const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }

    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
    let e = ""
    let formControlKey = "download"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey, journeyState)
    // getAllJourneyData(e, formControlKey)
  }

  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const contentType = "application/pdf";
      const blob = b64toBlob(base64Data, contentType);
      const blobUrl = URL.createObjectURL(blob);
    
      // Open PDF in a new tab
      const newTab = window.open(blobUrl, "_blank");
    
      // Optional: attempt to trigger print (may be blocked by some browsers)
      if (newTab) {
        newTab.onload = () => {
          newTab.print();
        };
      } else {
        alert("Popup blocked. Please allow popups for this site to view and print the PDF.");
      }
    }
    
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
    let e = ""
    let formControlKey = "print"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey, journeyState)
    // getAllJourneyData(e, formControlKey)
  }

  const sendEmail = async (callS3uploadPdf) => {
    if (!biApiData) {
      return
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
      TID: biApiData.TransactionId || "",
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
  }
  //async function to make API call
  const getData = async () => {
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
      productId: journeyState.productId
    }
    let journeyResult = await fetchAllJourneyData(payload)
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev => {
        return {
          ...prev,
          // premium:
          //   journeyState.planOption === "IATML"
          //     ? JSON.parse(data?.data?.BIJson)[0].TOTAL_5
          //     : journeyState.planOption === "IXTML"
          //       ? (
          //         JSON.parse(data?.data?.BIJson)[0].TOTAL_BASE_PREM_TAX +
          //         JSON.parse(data?.data?.BIJson)[0].TOTAL_PREM_TAX_SPOUSE || 0
          //       )?.toFixed(2)
          //       : "",
          premium:
            (data?.data?.finalKeys?.PREMIUM || 0),
            
          journeyData: applicationResult.applicationData,
        }
      })
      setBiApiData(data.data);
      pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
      .then(pdfResult => {
        setPdfData(pdfResult.data.Base64Pdf);
      })
      .catch(error => {
        console.error("Error while downloading PDF:", error);
      });

      getTOFpaymentReceipt(journeyState.applicationNo)
      .then(res => {
        const receipts = res.data || [];
        const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
        let sum = 0;
        validReceipts.forEach(receipt => {
          sum += parseInt(receipt.amount);
        });
        if (sum >= parseFloat(data.data?.finalKeys.PREMIUM)) {
          setSkipPayment(true);
        }
        setJourneyState(prev => ({
          ...prev,
          receipts: validReceipts 
        }));
      })
      .catch(err => console.info(err));

    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
  }

  const handleEnterPayoutOption = (event, value) => {
    console.log(event.key);
    if (event.key == 'Enter') {
      handlePayOption({ target: { value: value } })
    }

  }

  //Use Effects
  useEffect(async () => {
    await getData();
  }, [])

  // useEffect(() => {
  //   storePdfData()
  // }, [biApiData])

  //Page Functions
  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI");
    if (target.value === "now") {
      setPayNowOrLater("now")
      setIsPayBasba(false)
    } else if (target.value === "later") {
      setPayNowOrLater("later")
      setIsPayBasba(false)
    } else if (target.value === "basba") {
      setIsPayBasba(true)
    }
  }

  const handlePrevious = () => {
    let e ="previous"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Previous", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handlePrevious:", error);
    }
    if (proceedWithOption === "manually") {
      props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePrevious();
    }
  }
  // code of tab enter
  const handleEnterDownload = (event) => {
    if (event?.key == 'Enter') {
      downloadPdf();
    }
  }
  // code of tab enter
  const handleEnterPrint = (event) => {
    if (event?.key == 'Enter') {
      printPdf();
    }
  }
  // code of tab enter
  const handleEnterEmail = (event) => {
    if (event?.key == 'Enter') {
      sendEmail(true);
    }
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }

  const handleProceed = async ev => {
    if (!isChecked) {
      return;
    }
    let e ="proceed"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    // downloadLinkOfPdf(pdfData);
    sendEmail(true);
    const ageBI=calculateAge(allJourneyData?.lifeAssuredDetails?.dob)
    const spouseAgeBI = allJourneyData?.spouseDetails?.dob ? calculateAge(allJourneyData?.spouseDetails?.dob) : null;
    // const result = await s3uploadPdfBI({
    //   applicationNumber: journeyState.applicationNo,
    //   Base64Pdf: pdfData,
    // })
    // const b64Data = pdfData
    // const blob = b64toBlob(b64Data, "application/pdf")
    // let formData = new FormData()
    // if (blob) {
    //   const file = blob
    //   formData.append("doc", file)
    //   formData.append("sub", false)
    //   formData.append("docPurpose", "BIPDF")
    //   try {
    //     const res = await uploadDocument(formData, journeyState.applicationNo)
    //     console.log({ res })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // function b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || ""
    //   sliceSize = sliceSize || 512

    //   var byteCharacters = atob(b64Data)
    //   var byteArrays = []

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize)

    //     var byteNumbers = new Array(slice.length)
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i)
    //     }

    //     var byteArray = new Uint8Array(byteNumbers)

    //     byteArrays.push(byteArray)
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType })
    //   return blob
    // }
      let temp = journeyState.journeySteps.pages
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: {
            pages: temp,
          },
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium:
        (biApiData?.finalKeys.PREMIUM) || 0,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        isBasbaAttempted: isPayBasba ? "Y" : "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        ageAtBI:ageBI,
        spouseAgeAtBI:spouseAgeBI,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
          },
          posDashboardListingData:{
            canaraPosCaseType: "sendCaseToCustomer"
          }
      // base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) // this moves to first section of next page
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
  }

  const handleProceedSkipPayment = (e) => {
    e.preventDefault();
    const temp = journeyState.journeySteps;
    let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
    temp.pages[makePaymentPageIndex].sections = temp.pages[makePaymentPageIndex].sections.filter(section => section.sectionId === "eNach-physicalMandate")//show only e-nach section if skip payment
    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp
      }
    });
  
    let sendPayload = {
      applicationData: journeyState.journeyData,
      skipPayment:'Y',
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: (biApiData?.finalKeys.PREMIUM) || 0,
        lastPageCode: props.pageId,
        paymentStep: "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
      },
    }
  
    saveApplication(sendPayload).then(async res => {
      console.log(res, "application response");
      props.setCurrentPageIndex(prev => prev + 1);
      setErrorState({});
      props.setCurrentSectionIndex(0); // this moves to first section of next page
  
      // Save transaction details if skipPayment is true
      if (skipPayment) {
        const validReceipts = journeyState.receipts || [];
        const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
  
        const transactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Success',
          skipPayment: 'Y',
          transactions: transactions
        };

        let saveResp = await saveTransactionDetails(transactionPayload);
        console.log(saveResp, "saveTransactionDetails");
      }
      

    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration");
    });
  }

  const handleReCalculate = () => {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)
      try {
        const payload = {
          journeyId: journeyState?.journeyId, 
          buttonClicked: "ReCalculate", 
        };
  
        updateUserTrackerDetails(payload)
          .then((response) => {
            if (response?.status) {
              console.log("UserTracker updated successfully:", response.message);
            } else {
              console.error("Error in updating UserTracker:", response?.message);
            }
          })
          .catch((error) => {
            console.error("Error in updateUserTrackerDetails API call:", error);
          })
      } catch (error) {
        console.error("Error in handleReCalculate", error);
      }
      const tempPage = journeyState.journeyData?.find(page => page.pageId === ( journeyState.journeyIdFromStrapi === "youngTermPlanJourney" ? "PageYoungTermCalculatePremium" : "PageISelect360CalculatePremium"))
      console.log(tempPage, "tempPage")

      let sectionsTokeep = tempPage.pageData.filter((section => {
        return !["youngTermCPOptionalInBuilt", "youngTermCPSpouseCoverDetails"].includes(section.sectionId)
      }))
      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: sectionsTokeep,
        }
      })
      const tempState = tempPage.pageData.find(section => section.sectionId === "sectionYoungTermPersonalDetailsSection")
      console.log(tempState, "tempState")
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
      // setConditionState({})
    let e = ""
    let formControlKey = "reCalculate"
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, e, props.sections?.[props.currentSectionIndex]?.sectionId,formControlKey, journeyState)
    // getAllJourneyData(e, formControlKey)
  }

  const handleSendLinkToSales = (ev) => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    sendEmail(true);
    console.log("tesstttttt",journeyState.journeySteps.pages);
    let temp = journeyState.journeySteps

    temp.pages = temp.pages.filter(page => page.pageId !== "pageISelect360FillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "uploadDocuments")
    temp.pages.push(...lookup.sendLinktosales)
    if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
      temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
    }
    console.log(temp.pages)

    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        paymentStep: "L",
        journeyCode: findCurrentJourneyCode(
          props.pageId,
          props.sections[props.currentSectionIndex].sectionId
        ),
        canaraPosCaseType: "sendLinktosales"
      }
    })
  console.log("journeystateeee",journeyState);
  setSectionState(prev => {
    // making section data empty to load new sectionData
    return {
      ...prev,
      sectionId: null,
      sectionFirstPass: null,
      sectionData: {},
    }
  })
  // let optInPayload = {
  //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
  // }
  // let whatsAppOptres = whatsAppOptin(optInPayload)
  let sendPayload = {
    applicationData: journeyState.journeyData,
    journeyData: {
      _id: journeyState.journeyId,
      lastPage: props.currentPageIndex,
      lastSection: props.currentSectionIndex,
      applicationNo: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      proposalEntryId: journeyState.proposalEntryId,
      lastPageCode: props.pageId,
      paymentStep: payNowOrLater === "now" ? "N" : "L",
      lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
      planOption: journeyState.planOption,
      canaraPosCaseType: "sendLinktosales"
    },
    posDashboardListingData:{
      canaraPosCaseType: "sendLinktosales"
    }
  }
  saveApplication(sendPayload).then(res => {
    console.log(res, "application response")
    successToastr('Application will be visible on sales Dashboard')
    props.setCurrentPageIndex(prev => prev + 1)
    setErrorState({})
    setErrorState({})
    setErrorState({})
    setErrorState({})
    props.setCurrentSectionIndex(0) 
  }).catch(err => {
    console.log(err, "err in saveApplication benefit-illustration")
  })
  }



  return (
    <>
      {/* checkbox css */}
      <style>
        {`/* The container */
      .checkbox-label {
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      /* Hide the browser's default checkbox */
      .checkbox-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      /* Create a custom checkbox */
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #CCC;
        border-radius:0;
      }

      /* On mouse-over, add a grey background color */
      .checkbox-label:hover input ~ .checkmark {
        background-color: #ccc;
      }

      /* When the checkbox is checked, add a theme background */
      .checkbox-label input:checked ~ .checkmark {
        background-color:  ${journeyState.channel === "A"
            ? "#db0011"
            : journeyState.channel === "B"
              ? "#a20a3a"
              : journeyState.channel === "C"
                ? "#fec32b"
                : "#eb7f25"
          };
        background-color:  var(--lumiq-tertiary);
      };
      }

      /* Create the checkmark/indicator (hidden when not checked) */
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }

      /* Show the checkmark when checked */
      .checkbox-label input:checked ~ .checkmark:after {
        display: block;
      }

      /* Style the checkmark/indicator */
      .checkbox-label .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }`}
      </style>
      <style>
        {`
        .details-card{      
            border-radius:10px;
            overflow:hidden;
            margin-bottom:1rem;
            border:1px solid ${journeyState.channel === "A"
            ? "#000000"
            : journeyState.channel === "B"
              ? "#a20a3a"
              : journeyState.channel === "C"
                ? "#0ab0ef"
                : "#eb7f25"
          };     
            border:1px solid var(--lumiq-secondary);
        }
        
        .details-card::last-child{
            margin-bottom:0;       
        }
        
        .header{
            background: ${journeyState.channel === "A"
            ? "#000000"
            : journeyState.channel === "B"
              ? "#a20a3a"
              : journeyState.channel === "C"
                ? "#0ab0ef"
                : "#eb7f25"
          };
            background: var(--lumiq-secondary);
            color: #fff;
            padding:1rem;
            text-align:center;
        }

        .data{
            display:flex;
            justify-content:space-between;
            padding:1rem;
            color:#797979;

        }
 

        .data:nth-child(odd){
            background:#f3f3f3;
        }

        .data:nth-child(even){}

        .static-content h3{
          font-size:22px
        }

        @media screen and (max-width: 800px){
          .static-content h3{
            font-size: 18px;
          }
            
        }

        .disclosure > *{
            margin-bottom:1rem;

        }      
        .btn-actions{
            display:flex;
            justify-content:center;
            gap:2rem;
            flex-wrap:wrap;
        }

        .btn-actions > * {
          min-width:9rem;
          text-align:center;
        }


        .form-check{
          font-size:1.8rem;
      }

      .form-check-input{
          height:2.5rem;
          width:2.5rem
      }

        @media screen and (max-width:767px){
          .previous-btn{
            padding:0
          }
          
        }

        `}
      </style>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
          .benefitChange{
            display:flex;
            
          }
          .benefitPay{
            display:flex;
            // gap:2rem;
          }
          @media (max-width: 992px){
            .benefitPay .col-xs-12{
              width:100% !important;
            }
          }
              `}
      </style>

      <div className="landing-page1-design">
        <div className="container">
          {allJourneyData && biApiData && (
            <div className="row">
              <div className="col-md-12 ">
                <div className="iselect-box-design">
                  <div className="heading-design">
                    <div
                      className="iselect-padding left-side-head "
                      style={{ width: "65% !important" }}
                    >
                      <h1 className="iselect-heading">Benefit Illustration</h1>
                      <p style={{ paddingLeft: "1rem", marginTop: "1rem" }}>
                        Canara HSBC Life Insurance Company Limited {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]} | UIN: 136N087V03
                      </p>
                    </div>
                    <div className="app-quatation nri-mt-space hidden-desktop-screen">
                      <div className="application-design-number">
                        Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                  <div
                    className="iselect-padding"
                    style={{ paddingLeft: "2rem" }}
                  >
                    <h4>
                    Dear{" "}
                      {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. '
                          : ''
                        }
                        {wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { 
                        allJourneyData.lifeAssuredDetails.gender.toUpperCase() == "M" || allJourneyData.lifeAssuredDetails.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                        }
                        {wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }{" "}
                    </h4>
                    <p style={{ color: "#949494" }}>
                      Thank you for showing interest in our {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]}. Based on the details provided by you, the
                      illustration customised to your requirements is appended
                      below.
                    </p>
                  </div>

                  <div className="iselect-padding">
                    <div className="benefitChange row">
                      <div className="col-lg-6 col-md-12 col-xs-12">
                        <div className="details-card">
                          <div className="header">
                            <span>Life Assured Details</span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Name</span>
                            <span className="value">
                              {wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Date of Birth</span>
                            <span className="value">
                              {maskInFormat(
                                allJourneyData.lifeAssuredDetails.dob * 1000
                              )}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Gender</span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "gender",
                                allJourneyData.lifeAssuredDetails.gender
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Age</span>
                            <span className="value">
                              {JSON.parse(biApiData.BIJson)?.[0]
                                .LI_ATTAINED_AGE ?? "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Category</span>
                            <span className="value">
                              {allJourneyData.lifeAssuredDetails?.personalDetails?.smoking == "Y"
                                ? lineCapital("TOBACCO USER")
                                : lineCapital("NON-TOBACCO USER")}
                            </span>
                          </div>

                        {journeyState.planOption === "IXTML" && (
                          <>
                            <div className="data static-content">
                              <span className="field">
                                Premium Category:</span>
                              <span className="value">
                                {journeyState.planOption === "IXTML"
                                  ? lineCapital("MEDICAL")
                                  : "NA"
                                }
                              </span>
                            </div>
                            <div className="data static-content">
                              <span className="field">
                                Staff/Corporate Customer </span>
                              <span className="value">
                              {(allJourneyData.lifeAssuredDetails?.employmentDetails?.staff == "Y" || allJourneyData.productDetails?.corporateDiscountInd == "Y") ? "Yes" : "No"
                                }

                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  Existing/Salaried Customer </span>
                                <span className="value">
                                  {(allJourneyData.lifeAssuredDetails?.existingPolicyHolder == "Y" || allJourneyData.lifeAssuredDetails?.employmentDetails?.occupation == "1") ? "Yes" : "No"
                                  }
                                </span>
                              </div>

                            </>
                          )
                          }

                          <div className="data static-content">
                            <span className="field">Coverage Option</span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "coverOption",
                                allJourneyData.productDetails.coverOption
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          {/* <div className="data static-content">
                            <span className="field">Life Stage Enhancement</span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "yesNo",
                                allJourneyData.productDetails.lifeStageEnhancement
                              ) ?? '') || "NA"}
                            </span>
                          </div> */}
                          <div className="data static-content">
                            <span className="field">Benefit Payout Option</span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "benefitOption",
                                allJourneyData.productDetails.benefitOption
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Benefit Payout (lump sum)* (₹)
                            </span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                              //     .PART_LUMPSUM_AMOUNT ?? '0') || "NA"
                              //   :
                              //   journeyState.planOption === "IXTML"
                              //     ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                              //       .DB_LUMPSUM_LA ?? '0') || "NA"
                              //     : "NA" 
                              applyComma(biApiData?.finalKeys.BENEFIT_PAYOUT_LUMPSUM ?? '0') || "NA" 
                              }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Sum Assured (₹)</span>
                            <span className="value">
                              {applyComma(allJourneyData.productDetails.sumAssured) || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Plan Option</span>
                            <span className="value">
                              {(getValueFromLookup(
                                "planOption",
                                allJourneyData.productDetails.planOption
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Life Assured Death Benefit (₹)
                            </span>
                            <span className="value">
                              {applyComma(allJourneyData.productDetails.sumAssured) || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Benefit Payout (Part lumpsum part monthly income)*
                              Lump sum portion (₹)
                            </span>
                            <span className="value">
                              {applyComma(getValueFromLookup(
                                "lumpsumProportion",
                                allJourneyData.productDetails.proportion
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Benefit Payout (Part lumpsum part monthly income)*
                              Monthly income portion (₹)
                            </span>
                            <span className="value">
                              {journeyState.planOption === "IATML"
                                ? applyComma(getValueFromLookup(
                                  "benefitPayoutOptionsIndOther",
                                  allJourneyData.productDetails
                                    .benefitPayoutOptionsInd
                                ) ?? '') || "NA"
                                
                              : journeyState.planOption === "IXTML"
                                  ? applyComma(getValueFromLookup(
                                    "benefitPayoutOptionsIndIselect360",
                                    allJourneyData.productDetails
                                      .benefitPayoutOptionsInd
                                  ) ?? '') || "NA"
                                  : "NA"
                              }
                            </span>
                          </div>

                          <div className="data static-content">
                            <span className="field">
                              Premium Payment Frequency
                            </span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "premiumFrequency",
                                allJourneyData.productDetails.modeOfPayment
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Premium Paying Term (yrs)
                            </span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "policyTerm",
                                allJourneyData.productDetails.premiumPaymentTerm
                              ) ?? '') || "NA"}
                            </span>
                          </div>

                          <div className="data static-content">
                            <span className="field">
                              Benefit Payout* Monthly Income (₹):
                            </span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                              //     .part_monthly_amount ?? '0') || "NA"
                              //   :
                              //   journeyState.planOption === "IXTML"
                              //     ? applyComma(JSON.parse(biApiData.BIJson)?.[0]
                              //       .MONTHLY_INCOME_LA ?? '0') || "NA"
                              //     : "NA" 
                              applyComma(biApiData?.finalKeys.BENEFIT_PAYOUT_MONTHLY_INCOME ?? '0') || "NA"
                              }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Policy Term (yrs)</span>
                            <span className="value">
                              {lineCapital(getValueFromLookup(
                                "policyTerm",
                                allJourneyData.productDetails.policyTerm
                              ) ?? '') || "NA"}
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Additional Accidental Death Benefit (₹)
                            </span>
                            <span className="value">
                              {
                                journeyState.planOption === "IXTML"
                                  ? findRiderSA(
                                    "IXADB",
                                    allJourneyData.productDetails?.riders?.rider
                                  )
                                  : "NA"
                              }
                            </span>
                          </div>
                          {/* <div className="data static-content">
                          <span className="field">
                            Accidental Total & Permanent Disability Premium
                            Protection Plus (₹)
                          </span>
                          <span className="value">{"NA"}</span>
                        </div> */}
                          {journeyState.planOption === "IXTML" && (
                            <div className="data static-content">
                              <span className="field">
                                Child Care Benefit (₹)
                              </span>
                              <span className="value">
                                {findRiderSA(
                                  "IXCSB",
                                  allJourneyData.productDetails?.riders?.rider
                                )

                                }
                              </span>
                            </div>
                          )
                          }
                          {journeyState.planOption === "IXTML" && (
                            <>
                              <div className="data static-content">
                                <span className="field">
                                  Accidental Total & Permanent Disability (ATPD) - Premium Protection </span>
                                <span className="value">
                                  {
                                  allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name=== "IXATP1").length==1 ? "Yes" : "NA"
                                  }
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  Accidental Total & Permanent Disability (ATPD) - Premium Protection Plus </span>
                                <span className="value">
                                  {journeyState.planOption === "IXTML"
                                    ? findRiderSA(
                                      "IXATP2",
                                      allJourneyData.productDetails?.riders?.rider
                                    )
                                    : "NA"
                                  }
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  Terminal Illness (TI) </span>
                                <span className="value">
                                  {journeyState.planOption === "IXTML"
                                    ? findRiderSA(
                                      allJourneyData.productDetails.planOption === "IXTML1" ?  "IXTIP2" : "IXTIP", // TI name is IBTIP2 for IYTML2 
                                      allJourneyData.productDetails?.riders?.rider
                                    )
                                    : "NA"
                                  }
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  Block Your Premium (BYP) </span>
                                <span className="value">
                                {journeyState.planOption === "IXTML"
                                        ? findRiderSAPercent(
                                          "IXBYP1",
                                          allJourneyData.productDetails?.riders?.rider, 'bypSumAssured',"bypSaPercent"
                                        )
                                        : "NA"
                                      }
                                  {/* {
                                  allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name.includes("IBBYP")).map(data => (
                                    <>
                                      {getValueFromLookup2(
                                        "bypSumAssured",
                                        data.bypSaPercent)}</>
                                  ))} */}
                                </span>
                              </div>

                            </>
                          )
                          }
                          {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IXCSB").map(data => (
                            <>
                              <div className="data static-content">
                                <span className="field">
                                  Date of Birth of Child </span>
                                <span className="value">
                                  {getDateInFormat(
                                    allJourneyData.lifeAssuredDetails?.childDOB
                                  )}

                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  Gender of Child </span>
                                <span className="value">
                                  {lineCapital(getValueFromLookup(
                                    "gender",
                                    allJourneyData.lifeAssuredDetails?.childGender
                                  ) ?? '') || "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  CCB Policy Term (Years) </span>
                                <span className="value">
                                  {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IXCSB").map(data => (
                                    <div>{data.pt}</div>
                                  ))}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  CCB Premium Payment Term(Years) </span>
                                <span className="value">
                                  {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IXCSB").map(data => (
                                    <div>{data.ppt}</div>
                                  ))}
                                </span>
                              </div>
                            </>
                          ))}
                          {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IXATC1").map(data => (
                            <div>
                              <div className="data static-content">
                                <span className="field">
                                  CI Policy Term (Years) </span>
                                <span className="value">
                                  {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IXATC1").map(data => (
                                    <div>{data.pt}</div>
                                  ))}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">
                                  CI Premium Payment Term (Years) </span>
                                <span className="value">
                                  {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IXATC1").map(data => (
                                    <div>{data.ppt}</div>
                                  ))}
                                </span>
                              </div>
                            </div>
                          ))}



                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12 col-xs-12">
                        {allJourneyData?.productDetails?.spouseLaDetails
                          ?.wishToSecure === "02" && (
                            <div className="details-card">
                              <div className="header">
                                <span>Spouse Details</span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Name</span>
                                <span className="value">
                                  {" "}
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? wordCapital(allJourneyData?.spouseDetails?.firstName ?? '') +
                                    " " +
                                    wordCapital(allJourneyData?.spouseDetails?.middleName ?? '') +
                                    " " +
                                    wordCapital(allJourneyData?.spouseDetails?.lastName ?? '')
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Date of Birth</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? maskInFormat(
                                      allJourneyData?.spouseDetails?.dob * 1000
                                    )
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Gender</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? lineCapital(getValueFromLookup(
                                      "gender",
                                      allJourneyData?.spouseDetails?.gender
                                    ) ?? '')
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Age</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? JSON.parse(biApiData.BIJson)?.[0]
                                      .SPOUSE_AGE_DISPLAY ?? "NA"
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Annual Income</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    &&
                                    allJourneyData?.spouseDetails?.employmentDetails?.annualIncome
                                    ? allJourneyData?.spouseDetails?.employmentDetails?.annualIncome.slice(0, 2) + "*****" + allJourneyData?.spouseDetails?.employmentDetails?.annualIncome.slice(-2)
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Sum Assured</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? applyComma(allJourneyData?.productDetails?.spouseLaDetails
                                      ?.spouseSa ?? '')
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Category</span>
                                <span className="value">
                                  {allJourneyData?.spouseDetails?.personalDetails?.smoking == "Y"
                                    ? lineCapital("TOBACCO USER")
                                    : lineCapital("NON-TOBACCO USER")}
                                </span>
                              </div>
                              {/* {journeyState.planOption === "IXTML" && (
                                <>
                                  <div className="data static-content">
                                    <span className="field">
                                      Staff/Corporate Customer </span>
                                    <span className="value">
                                      No
                                    </span>
                                  </div>
                                  <div className="data static-content">
                                    <span className="field">
                                      Existing/Salaried Customer </span>
                                    <span className="value">
                                      No
                                    </span>
                                  </div>
                                </>
                              )
                              } */}
                              <div className="data static-content">
                                <span className="field">Coverage </span>
                                <span className="value">
                                  {getValueFromLookup(
                                    "coverOption",
                                    allJourneyData.productDetails.spouseLaDetails
                                      ?.spouseCoverOption
                                  ) || "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Benefit Payout Option</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? getValueFromLookup(
                                      "benefitOption",
                                      allJourneyData.productDetails
                                        ?.spouseLaDetails?.spousebenAmtRcvInd
                                    )
                                    : "NA"}
                                </span>
                              </div>
                              <div className="data static-content">
                                <span className="field">Plan Option</span>
                                <span className="value">
                                  {allJourneyData?.productDetails?.spouseLaDetails
                                    ?.wishToSecure == "02"
                                    ? getValueFromLookup(
                                      "planOption",
                                      allJourneyData.productDetails.planOption
                                    )
                                    : "NA"}
                                </span>
                              </div>
                              {journeyState.planOption === "IXTML" && (
                                <>
                                  <div className="data static-content">
                                    <span className="field">
                                      Additional Accidental Death Benefit (₹)
                                    </span>
                                    <span className="value">
                                      {journeyState.planOption === "IXTML"
                                        ? findRiderSA(
                                          "IXADB1",
                                          allJourneyData.productDetails?.riders?.rider
                                        )
                                        : "NA"
                                      }
                                    </span>
                                  </div>

                                  <div className="data static-content">
                                    <span className="field">
                                      Child Care Benefit (₹)
                                    </span>
                                    <span className="value">
                                      {
                                        journeyState.planOption === "IXTML"
                                          ? findRiderSA(
                                            "IXATC4",
                                            allJourneyData.productDetails?.riders?.rider
                                          )
                                          : "NA"
                                      }
                                    </span>
                                  </div>
                                  <div className="data static-content">
                                    <span className="field">
                                      Accidental Total & Permanent Disability (ATPD) - Premium Protection </span>
                                    <span className="value">
                                    {
                                      allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IXATP3").length==1 ? "Yes" : "NA"
                                  }
                                    </span>
                                  </div>
                                  <div className="data static-content">
                                    <span className="field">
                                      Accidental Total & Permanent Disability (ATPD) - Premium Protection Plus </span>
                                    <span className="value">
                                      {journeyState.planOption === "IXTML"
                                        ? findRiderSA(
                                          "IXATP4",
                                          allJourneyData.productDetails?.riders?.rider
                                        )
                                        : "NA"
                                      }
                                    </span>
                                  </div>
                                  <div className="data static-content">
                                    <span className="field">
                                      Terminal Illness (TI) </span>
                                    <span className="value">
                                      {journeyState.planOption === "IXTML"
                                        ? findRiderSA(
                                          "IXTIP1",
                                          allJourneyData.productDetails?.riders?.rider
                                        )
                                        : "NA"
                                      }
                                    </span>
                                  </div>
                                  <div className="data static-content">
                                    <span className="field">
                                      Block Your Premium (BYP) </span>
                                    <span className="value">
                                    {journeyState.planOption === "IXTML"
                                        ? findRiderSAPercent(
                                          "IXBYP1",
                                          allJourneyData.productDetails?.riders?.rider, "bypSumAssured","bypSpouseSaPercent"
                                        )
                                        : "NA"
                                      }
                                      {/* {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name.includes("IBBYP1")).map(data => (
                                        <>
                                          {getValueFromLookup2(
                                            "bypSumAssured",
                                            data.bypSpouseSaPercent) || "NA"}</>
                                      ))} */}
                                    </span>
                                  </div>
                                  {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IXATC4").map(data => (
                                    <>
                                      <div className="data static-content">
                                        <span className="field">
                                          Date of Birth of Child </span>
                                        <span className="value">
                                          {getDateInFormat(
                                            allJourneyData.spouseDetails?.childDOB
                                          )}
                                        </span>
                                      </div>
                                      <div className="data static-content">
                                        <span className="field">
                                          Gender of Child </span>
                                        <span className="value">
                                          {lineCapital(getValueFromLookup(
                                            "gender",
                                            allJourneyData.spouseDetails?.childGender
                                          ) ?? '') || "NA"}
                                        </span>
                                      </div>
                                      <div className="data static-content">
                                        <span className="field">
                                          CCB Policy Term (Years) </span>
                                        <span className="value">
                                          {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name==="IXATC4").map(data => (
                                            <div>{data.pt}</div>
                                          ))}
                                        </span>
                                      </div>
                                      <div className="data static-content">
                                        <span className="field">
                                          CCB Premium Payment Term(Years) </span>
                                        <span className="value">
                                          {allJourneyData.productDetails?.riders?.rider.filter(ele => ele.name === "IXATC4").map(data => (
                                            <div>{data.ppt}</div>
                                          ))}
                                        </span>
                                      </div>
                                    </>
                                  ))}
                                </>
                              )
                              }


                            </div>
                          )}
                        <div className="details-card">
                          <div className="header">
                            <span>Total Premium Payable (₹)</span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Installment Premium (Life Assured + Rider Premium
                              (If applicable))
                            </span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(`${JSON.parse(biApiData?.BIJson)[0].TOTAL_1}` ?? '')
                              //   : journeyState.planOption === "IXTML"
                              //     ? applyComma(`${JSON.parse(biApiData?.BIJson)[0].TOTAL_PREM_LA}` ?? '')
                              //     : "NA"
                              applyComma(biApiData?.finalKeys.INSTALLMENT_PREM_LA_RIDER ?? '')
                                  }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Installment Premium (Spouse Cover)
                            </span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].TOTAL_2}` ?? '')
                              //   : journeyState.planOption === "IXTML"
                              //     ? applyComma(`${JSON.parse(biApiData.BIJson)[0]
                              //       .TOTAL_SPOUSE_PREM}` ?? '') || 0
                              //     : "NA"
                              applyComma(biApiData?.finalKeys.INSTALLMENT_PREM_SPOUSE ?? '') || 0
                                  }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Total Installment</span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].MODAL_PREM}` ?? '')
                              //   : journeyState.planOption === "IXTML"
                              //     ? applyComma(`${(
                              //       JSON.parse(biApiData.BIJson)[0]
                              //         .TOTAL_PREM_LA +
                              //       JSON.parse(biApiData.BIJson)[0]
                              //         .TOTAL_SPOUSE_PREM || 0
                              //     )?.toFixed(2)}` ?? '')
                              //     : "NA"
                              applyComma(biApiData?.finalKeys?.TOTAL_INSTALLMENT ?? '') || 0
                                  }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Goods and Services Tax & Applicable Cess (es)/Levy,
                              if any
                            </span>
                            <span className="value">
                              { 
                              //  journeyState.planOption === "IATML"
                              //   ? JSON.parse(biApiData.BIJson)[0].TAX_MP
                              //   : journeyState.planOption === "IXTML"
                              //     ? journeyState.gstWaiverInd === "N" ?
                              //       applyComma(`${(
                              //       (JSON.parse(biApiData.BIJson)[0]
                              //         .TOTAL_BASE_PREM_TAX +
                              //         JSON.parse(biApiData.BIJson)[0]
                              //           .TOTAL_PREM_TAX_SPOUSE || 0) -
                              //       (JSON.parse(biApiData.BIJson)[0]
                              //         .TOTAL_PREM_LA +
                              //         JSON.parse(biApiData.BIJson)[0]
                              //           .TOTAL_SPOUSE_PREM || 0)
                              //     )?.toFixed(2)}` ?? '')
                              //     : 0 :"NA" 
                              applyComma(biApiData?.finalKeys?.SERVICE_TAX ?? '') || 0
                                  
                                }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">Amount Payable</span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].TOTAL_5}` ?? '')
                              //   : journeyState.planOption === "IXTML"
                              //     ? ((
                              //       JSON.parse(biApiData.BIJson)[0]
                              //         .TOTAL_BASE_PREM_TAX +
                              //       JSON.parse(biApiData.BIJson)[0]
                              //         .TOTAL_PREM_TAX_SPOUSE || 0
                              //     )?.toFixed(2) ?? '')
                              //     : "NA"
                              applyComma(biApiData?.finalKeys?.PREMIUM ?? '') || 0
                                  }
                            </span>
                          </div>
                          <div className="data static-content">
                            <span className="field">
                              Total Amount Payable for the Year
                            </span>
                            <span className="value">
                              {
                              // journeyState.planOption === "IATML"
                              //   ? applyComma(`${JSON.parse(biApiData.BIJson)[0].ANN_TOTAL_5}` ?? '')
                              //   : journeyState.planOption === "IXTML"
                              //     ? applyComma(`${JSON.parse(biApiData.BIJson)[0].TOTAL}` ?? '')
                              //     : "NA"
                              applyComma(biApiData?.finalKeys?.TOTAL_AMOUNT_PER_YEAR ?? '') || 0
                                  }
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p
                      className="text-center col-md-12 col-xs-12"
                      style={{
                        padding: "2rem 4rem",
                      }}
                    >
                      This is applicable only for Level Cover Option. For
                      Increasing Cover Option the amount will increase as per
                      terms and conditions of the policy.
                    </p>

                    <div className="btn-actions col-md-12 col-xs-12">
                      <div
                        style={{ cursor: "pointer" }}
                        className="provider submit-btn"
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                      >
                        <a>Download</a>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="provider submit-btn"
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a>Print</a>
                      </div>
                      <div
                        style={{ cursor: "pointer" }}
                        className="provider submit-btn"
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {sendEmail(true)}}
                      >
                        <a>Email</a>
                      </div>
                      <div
                        style={{
                          cursor:
                            proceedWithOption === "manually"
                              ? "pointer"
                              : "default",
                        }}
                        className={
                          proceedWithOption === "manually"
                            ? "provider submit-btn"
                            : "provider manually-submit-btn"
                        }
                        tabIndex="0"
                        disabled={
                          proceedWithOption === "manually" ? false : true
                        }
                        onKeyPress={(e) => handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                      >
                        <a>Re-Calculate</a>
                      </div>
                    </div>
                  </div>
                  {skipPayment && <p style={{
                    textAlign : "center",
                    fontSize : "18px",
                    marginTop : "30px"

                  }}>Premium of Rs {biApiData?.finalKeys?.PREMIUM} is adjusted against transfer of funds from old application</p>}

                  <div className="iselect-mg-bottom check-design">
                    <div className="col-md-12 col-xs-12">
                      <div className="transactionDetailsWrap del-agree">
                        <div className="detailContentWrap">
                          <div
                            className="row iAgree"
                            style={{ textAlign: "center" }}
                          >
                            <div className="form-group">
                              <div className="inner-addon left-addon align-error payment-align-error" >
                                <div className="checkbox1">
                                  <input
                                    id="checkboxG6"
                                    className={`css-checkbox form-control`}
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleOnChange}
                                  />

                                  <label
                                    htmlFor="checkboxG6"
                                    className="css-label"
                                  >
                                    I agree to the Disclosures and Disclaimers
                                    as mentioned below.
                                  </label>
                                </div>
                                {!isChecked && (<span className="input-error " style={{ fontSize: '13px', marginLeft: "5.2rem" }}>
                                  Please accept Terms & Conditions
                                </span>)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 
                  <div
                    style={{
                      textAlign: "center",
                      marginBottom: "4rem",
                    }}
                  >
                    <label className="checkbox-label static-content">
                      I agree to the Disclosures and Disclaimers as mentioned
                      below.
                      <input type="checkbox" onClick={handleAgreeChange} />
                      <span className="checkmark"></span>
                    </label>
                  </div> */}

                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                      {
                          allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                          (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                          <div
                                className={
                                  proceedWithOption === "manually"
                                    ? "provider submit-btn cen"
                                    : "provider manually-submit-btn cen"
                                } tabIndex="0" onKeyPress={(e) => handleEnterPrevious(e)}
                              >
                                <a
                                  style={{
                                    cursor:
                                      proceedWithOption === "manually"
                                        ? "pointer"
                                        : "default",
                                  }}
                                  aria-hidden="true"
                                  onClick={handlePrevious}
                                >
                                  Previous
                                </a>
                              </div>
                          :
                            (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                            <div
                                className={
                                  proceedWithOption === "manually"
                                    ? "provider submit-btn cen"
                                    : "provider manually-submit-btn cen"
                                } tabIndex="0" onKeyPress={(e) => handleEnterPrevious(e)}
                              >
                                <a
                                  style={{
                                    cursor:
                                      proceedWithOption === "manually"
                                        ? "pointer"
                                        : "default",
                                  }}
                                  aria-hidden="true"
                                  onClick={handlePrevious}
                                >
                                  Previous
                                </a>
                              </div>
                          }
                        <input
                          type="submit"
                          className="provider previous-btn cen"
                          tabIndex="0"
                          style={{
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                            marginLeft: "8px",
                          }}
                          value="Proceed"
                          onClick={skipPayment ? handleProceedSkipPayment : handleProceed}
                          disabled={!agreeToDeclaration}
                        />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
                      </div>
                    </div>
                  </div>
                    <div className="static-content">
                      <h3
                        style={{
                          marginLeft: "2rem",
                          marginTop: "15rem",
                        }}
                      >
                        Disclosures:{" "}
                      </h3>
                      <ol className="disclosure" style={{textAlign:"justify"}}>
                        <li>
                          Canara HSBC Life Insurance Company Limited {lookup['pageTitle'][jounrneyJSON.data.products[0].planId]} is an Individual Non-Linked
                          Non-Par Pure Risk Premium Life Insurance Term Plan.
                        </li>
                        <li>
                        Tax benefits under the plan may be available as per the prevailing Income Tax laws and are subject to amendments from time to time. 
                        For tax related queries, contact your independent tax advisor. 
                        </li>
                        <li>
                        The above illustration takes into account currently applicable 
                        Goods and Services Tax including applicable cess(es)/other levy,
                         if any. However, the applicable taxes may change from time to 
                         time and premium payable will change accordingly. 
                        </li>
                        <li>
                          In case of Regular/ Limited Pay policies under plan
                          option Life, if due premium is not paid within the
                          Grace Period, then policy will lapse at the expiry of
                          the Grace Period. For Regular Pay policies, insurance
                          cover will cease immediately. However, for Limited Pay
                          policies, provided all the premiums due for the first
                          2 consecutive policy years have been paid, an Early
                          Exit Value shall be payable on the earliest of the
                          following terminations: <br/> a) death of the life assured/
                          spouse when policy has lapsed <br/> b) request for
                          termination of the policy by the policyholder <br/> c)
                          expiry of revival period.
                        </li>
                        <li>
                        In Single Premium policies, the surrender benefit will be available
                         from the first policy year and in case of Limited Premium policies,
                          the surrender benefit will be available after payment of all premiums
                           due under the Policy as per the chosen Premium Payment Term.
                            In Regular Premium policies, Early Exit Values/ 
                            Surrender Benefit is not applicable. 
                        </li>
                        <li>
                          The cover under the Optional In-Built covers (if opted) will remain
                          the same throughout the policy term, it will not increase if increasing 
                          cover option has been chosen. Sum Assured under the Optional
                          In-Built Covers can only be paid in the form of lump sum payment.
                        </li>
                        <li>
                          Where Terminal Illness Optional In-Built cover has been opted, 
                          on diagnosis of the same, cover for all other Optional In-Built Covers will cease. 
                        </li>
                        <li>
                          The premium rate under Block Your Premium will be blocked for
                          Base cover only and not for any Optional In-Built Covers. 
                          The increase in Sum Assured shall be applicable for Base Sum
                          Assured only and not for any Optional In-built covers.
                        </li>
                        <li>
                          The premium rates for the CI benefit are guaranteed for a period of 5 years
                          from the risk commencement date of the Policy and can be revised thereafter.
                          Once revised, these rates become guaranteed for a period of next 5 years. 
                          The Company will inform the policyholder about the premium revision, 
                          if any, at least 3 months in advance of the premium due date from which 
                          the new rate will be applicable. 
                        </li>
                        <li>
                        Annualised Premium is the Premium payable in a year for the base Death
                         Benefit for Life Assured, excluding the corresponding taxes, rider premiums,
                          underwriting extra premiums and loadings for modal premiums, if any. Single
                           Premium is the Premium payable at outset for the base Death Benefit for
                            Life Assured/Spouse, excluding the corresponding taxes, rider premiums
                             and underwriting extra premiums, if any. 
                        </li>
                      </ol>
                      <h3
                        style={{
                          marginLeft: "2rem",
                          marginTop: "30px",
                          marginBottom:"20px"
                        }}
                      >
                        Disclaimers:
                      </h3>
                      <ol className="disclosure" type="a" style={{textAlign:"justify"}}>
                        <li>
                          Issuance of the policy and acceptance of the risk is
                          completely at the discretion of Canara HSBC
                          Bank of Commerce Life Insurance Company Limited
                          ("Company") and this premium quotation would in no way
                          be tantamount to acceptance of risk by the Company.
                        </li>
                        <li>
                          The above premium is for a healthy individual. Your
                          application will be assessed as per Board Approved
                          Underwriting Policy of the Company. Basis
                          underwriting, it may result in an extra premium to be
                          paid, which shall be borne by you.
                        </li>
                        <li>
                          These figures are assuming happening of event at
                          policy inception.
                        </li>
                        <li>
                          For more details on risk factors, terms and
                          conditions, please read sales brochure carefully
                          before concluding a sale.
                        </li>
                        <li>
                          The mentioned quote is valid till next birthday or 30
                          days from the quote generation date whichever is
                          earlier.
                        </li>
                        <li style={{testAlign:"initial"}}>
                          For any further clarifications, please feel free to
                          contact us at {getSourceFromChannel(journeyState.channel) === "U" ?  "1800-258-5899" : "1800-891-0003"} or email us
                          at customerservice@canarahsbclife.in or visit our
                          website{" "}
                          <a
                            href="https://www.canarahsbclife.com"
                            target="_blank"
                          >
                            www.canarahsbclife.com.
                          </a>
                        </li>
                        <li style={{listStyleType: "none"}}>
                            Trade Logo of Canara HSBC Life Insurance Company Limited hereinafter referred to as "Insurer" is used under license with Canara Bank and HSBC 
                             Group Management Services Limited. The Insurance products are offered and underwritten
                              by Insurer <strong> (IRDAI Regn. No. 136)</strong> having its head office at 139 P, Sector-44, Gurugram 
                              122003, Haryana. For more details on risk factors, terms and conditions please read 
                              the sales brochure carefully before concluding a sale. 
                              Corporate Identity No.: U66010DL2007PLC248825. Website: www.canarahsbclife.com. 
                              Call:1800-103-0003/1800-180-0003/1800-891-0003. Give a missed call to: 0124-6156600. 
                              SMS: 9779030003. Email: {getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"}
                        </li>
                      </ol>
                    </div>
                  {/* <!--mobile view button--> */}
                  <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
                    <div className="iselect-mg-bottom">
                      <div className="col-md-12">
                        <div className="but-center text-center">
                        {
                          allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                          (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                          <div
                              className="submit-btn cen"
                              style={{ marginRight: "5px" }}
                              >
                              {" "}
                              <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                              </div>
                          :
                            (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                            <div
                                className="submit-btn cen"
                                style={{ marginRight: "5px" }}
                                >
                                {" "}
                                <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                                </div>
                          }
                          <div className="previous-btn cen">
                            <a>
                              {" "}
                              <button
                                type="submit"
                                value="button1"
                                style={{
                                  backgroundColor: "transparent",
                                  padding: "14px 10px",
                                  border: "none",
                                  color: "#fff",
                                }}
                                onClick={skipPayment ? handleProceedSkipPayment : handleProceed}
                                disabled={!agreeToDeclaration}
                              >
                                Proceed
                              </button>{" "}
                            </a>TOB
                          </div>
                          {allJourneyData?.journeyType === "CanaraPos" &&
                            <div className="previous-btn cen send-link-to-cust">
                              <span>
                                <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                              </span>
                            </div>
                          }
                          {/* <div className="previous-btn cen send-link-to-cust">
                            {allJourneyData?.journeyType === "CanaraPos" &&
                              <span>
                              <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                              </span>
                            }
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--mobile view button-->  */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
